module.exports={account_link_complete_message:"Nexon Hesabı Bağlantısı tamamlandı."};